import React, { useState } from 'react';
import { useTranslation } from '~/Locale';
import Auction, { AuctionType } from '~/App/shared/interfaces/Auction';
import { Subtitle } from '@kvdbil/components';
import styled from 'styled-components';
import { getAllowedResidualLoan } from '~/helpers/calculator';
import { getIsCertified } from '~/helpers/auction';
import { useCmsData } from '~/App/shared/hooks/useCmsData';
import {
  ObjectServicesDocument,
  ObjectServicesQuery
} from '~/config/generated/graphql';
import { ObjectServicesData } from '~/App/shared/interfaces/store/CmsData';
import { ServicesSwitcher } from './components/ServicesSwitcher';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';

export const ServiceContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscaleToned.light6};
`;

const Title = styled(Subtitle)`
  text-align: center;
  margin-bottom: 3rem;
`;

interface Props {
  auction: Auction;
  auctionCost: number;
  buyMethod: AuctionType | null;
  isReleasingServiceVisible?: boolean;
  isFinanceServiceVisible?: boolean;
  showReleasingForm?: boolean;
  isServiceAgreementReleasingVisible?: boolean;
  releasingInformation?: Record<string, undefined>;
}

const AdditionalServices = ({
  auction,
  auctionCost,
  buyMethod,
  isReleasingServiceVisible = true,
  isFinanceServiceVisible = true,
  isServiceAgreementReleasingVisible = false,
  showReleasingForm = true,
  releasingInformation = {}
}: Props) => {
  const { t } = useTranslation();
  const [releasingInformationAccordion, setReleasingInformationAccordion] =
    useState({});
  const { data: cmsData } = useCmsData<ObjectServicesQuery, ObjectServicesData>(
    {
      storeKey: 'objectServices',
      query: ObjectServicesDocument
    }
  );

  const shouldCalculateResidualLoan = getAllowedResidualLoan(
    auction.processObject
  );

  const processObject = auction?.processObject;
  const orderableServices = processObject?.orderableAdditionalServices || {};
  const isCertified = getIsCertified(processObject);

  return (
    <div data-testid="auction-services">
      <Title>{cmsData?.servicesTitle ?? t('Additional services')}</Title>
      {cmsData &&
        cmsData.servicesData?.map(data => {
          return (
            <ServicesSwitcher
              key={data.id}
              cmsData={data as CMSDataObjectPageService}
              auction={auction}
              auctionCost={auctionCost}
              buyMethod={buyMethod}
              isReleasingServiceVisible={isReleasingServiceVisible}
              isFinanceServiceVisible={isFinanceServiceVisible}
              showReleasingForm={showReleasingForm}
              isServiceAgreementReleasingVisible={
                isServiceAgreementReleasingVisible
              }
              releasingInformation={releasingInformation}
              releasingInformationAccordion={releasingInformationAccordion}
              setReleasingInformationAccordion={
                setReleasingInformationAccordion
              }
              orderableServices={orderableServices}
              shouldCalculateResidualLoan={shouldCalculateResidualLoan}
              processObject={processObject}
              isCertified={isCertified}
            />
          );
        })}
    </div>
  );
};

export default AdditionalServices;
